import { render } from "./SIdentify.vue?vue&type=template&id=2fd78f21"
import script from "./SIdentify.vue?vue&type=script&lang=js"
export * from "./SIdentify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__